var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#232323;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.7,282.39l25.55,68.36c6.68,17.88,11.4,41.74,24.46,56.24C71,422.82,90.83,419.24,105,405.48c16.7-16.28,31.67-34.73,47.33-52,59.82-66,121.42-132.37,197.27-180.29,40.93-25.86,85-45.52,132.3-56.09,22.15-4.94,12.78-39-9.38-34-98.7,22-183.13,82-255,151-39.28,37.71-75.52,78.39-112,118.72-8.2,9.05-20.93,18.88-27,29.39q6.91,3.74,2.88-1.23a52.26,52.26,0,0,1-3.25-8c-2.4-6.09-4.59-12.27-6.88-18.41L40.72,273c-7.88-21.08-42-11.95-34,9.38Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckicon);
export default __webpack_public_path__ + "static/media/check icon.47c49fc14dea49097d063040af46fb5e.svg";
export { ForwardRef as ReactComponent };